<template>
  <div class="popup-full  _new-design  modal-saved-to-favorites">
    <div class="popup-full__wrap">

      <button type="button"
              @click.prevent="onClose"
              class="popup-full__close">
        <BaseSvg name="ico-close"/>
      </button>
      <div class="popup-full__scroll">
        <div class="popup-full__content">
          <div class="popup-full__main">
            <div class="popup-full__media">
              <picture class="popup-full__img">
                <img src="../assets/img/popup/saved-to-favorites.svg"
                     :alt="$tVacancy('Vacancy saved')">
              </picture>
            </div>

            <h3 class="popup-full__title">{{ $tVacancy('Vacancy saved') }}</h3>
            <h4 class="popup-full__sub-title-note">
              <b>{{ $tVacancy('Total vacancies saved') }}</b>
              <template v-if="bookmarksQuantity">
                {{ bookmarksQuantity }}
              </template>
            </h4>
            <div class="popup-full__text text">
              <p>{{
                  (!isLogged && bookmarksQuantity === 1)
                    ? $tVacancy('modal_saved_to_favorites_no_auth_description')
                    : $tVacancy('modal_saved_to_favorites_description')
                }}</p>
            </div>
          </div>

          <div class="popup-full__buttons">
            <router-link-modified :to="{name: 'account-my-vacancies', query: {
                                    currentTab: 2
                                  }}"
                                  @click.native="onClose"
                                  class="popup-full__btn  base-btn  base-btn--outline-dark">
              <span class="base-btn__text">
                {{ $tVacancy('See saved to bookmarks') }}
              </span>
            </router-link-modified>

            <router-link-modified v-if="!isLogged && bookmarksQuantity === 1"
                                  :to="{name: 'auth', query: {'for-mass-sent': 'true', 'redirect': this.$route.fullPath}}"
                                  @click.native="onClose"
                                  class="popup-full__btn  base-btn  base-btn--outline-green">
              <span class="base-btn__text">
                {{ $tVacancy('Register for respond on all') }}
              </span>
            </router-link-modified>

            <router-link-modified v-else-if="!isLogged"
                                  :to="{name: 'auth', query: {'for-mass-sent': 'true'}}"
                                  @click.native="onClose"
                                  class="popup-full__btn  base-btn  base-btn--outline-green">
              <span class="base-btn__text">
                {{ $tVacancy('Respond to all') }}
              </span>
              <BaseSvg name="ico-arrow-light"
                       width="0.6rem"
                       height="0.9rem"
                       style="margin-left: 0.6rem"/>
            </router-link-modified>

            <button v-else-if="bookmarksQuantity > 1"
                    type="button"
                    @click.prevent="respondToAll"
                    class="popup-full__btn  base-btn  base-btn--outline-green">
              <span class="base-btn__text">
                {{ $tVacancy('Respond to all') }}
              </span>
              <BaseSvg name="ico-arrow-light"
                       width="0.6rem"
                       height="0.9rem"
                       style="margin-left: 0.6rem"/>
              <BasePreloader v-if="pendingRespondOnAll"/>
            </button>
          </div>

          <button type="button"
                  @click.prevent="onClose"
                  class="modal-saved-to-favorites__bottom-btn  popup-full__btn    base-btn  base-btn--outline-grey--blue">
              <span class="base-btn__text">
                {{ $tVacancy('See more') }}
              </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {EMPLOYEE} from '@/constants/usersTypes'
  import respondOnAllBooked from '@/actions/respondOnAllBooked'

  export default {
    name: 'ModalSavedToFavorites',
    props: {
      bookmarksQuantity: Number
    },
    data() {
      return {
        pendingRespondOnAll: false,
      }
    },
    computed: {
      ...mapGetters('user', [
        'isLogged',
      ]),
      isEmployee() {
        return this.$store.state.user.profile
          && this.$store.state.user.profile.user_type === EMPLOYEE
      },
    },
    methods: {
      onClose() {
        this.$vModal.close('saved-to-favorites')
      },
      respondToAll() {
        this.pendingRespondOnAll = true

        respondOnAllBooked().then(() => {
          this.onClose()
        }).finally(() => {
          this.pendingRespondOnAll = false
        })
      }
    }
  }
</script>

<style lang="less">

</style>
